import TextArea from './ant';

export default TextArea;
